import Button from 'components/UI/Button';
import Logo from 'static/images/logo.png';
import bgVideo from 'static/videos/hero.mp4';
import heroImage from 'static/images/hero.png';
import { ReactComponent as MenuBurgerIcon } from 'static/icons/menu-burger.svg';
import { ReactComponent as HeroBtnLeft } from 'static/icons/hero-btn-lft.svg';
import { ReactComponent as HeroBtnRight } from 'static/icons/hero-btn-rgt.svg';
import { ReactComponent as XIcon } from 'static/icons/X-icon.svg';
import {
  Wrapper,
  BackgroundImageWrapper,
  Overlay,
  ContentWrapper,
  Nav,
  LogoBox,
  NavButtons,
  HamBurger,
  HeroSection,
  HeroTitle,
  HeroText,
  HeroSectionButton,
  Menu,
  NavButtonsWrapper,
  StartButtons,
  RequestDemoButton
} from './styles/HeroSection.styles';
import { useState } from 'react';
import getAuthToken from 'utils/cookie';
import { useNavigate } from 'react-router-dom';

export default function HeroSectionv2() {
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);

  const loginClickHandler = () => {
    const tokenValue = getAuthToken();
    if (tokenValue) {
      navigate(`/coverage/#id_token=${tokenValue}`);
    } else {
      navigate('/login', { state: { prevLandingPage: true } });
    }
  };

  const signUpClickHandler = () => {
    const tokenValue = getAuthToken();
    if (tokenValue) {
      navigate(`/coverage/#id_token=${tokenValue}`);
    } else {
      navigate('/signup', { state: { prevLandingPage: true } });
    }
  };

  return (
    <Wrapper>
      <BackgroundImageWrapper>
        <video
          poster={heroImage}
          autoPlay
          muted
          loop
          playsInline
          webkit-playsinline="true"
          preload="auto">
          <source src={bgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <Overlay />
      </BackgroundImageWrapper>

      <ContentWrapper>
        <Nav>
          <div className="flex items-center">
            <LogoBox>
              <img src={Logo} alt="" />
            </LogoBox>
          </div>
          <NavButtons>
            <div className="start-buttons">
              <Button
                element="link"
                to="https://calendly.com/fullframe-support/30min?month=2023-09"
                variant="ghost">
                REQUEST DEMO
              </Button>
              <p>|</p>
              <Button onClick={loginClickHandler} variant="ghost" className="ghost">
                LOG IN
              </Button>
            </div>
            <Button
              onClick={signUpClickHandler}
              className="!text-[#000000] px-6 rounded-[6px] bg-white h-[46px] w-[134px]">
              Try for Free
            </Button>
          </NavButtons>
          <HamBurger onClick={() => setIsShow((prev) => !prev)}>
            {isShow ? <XIcon /> : <MenuBurgerIcon />}
          </HamBurger>
        </Nav>

        <HeroSection className="text-[#ffffff]">
          <HeroTitle>
            Script Coverage for Film &
            <br />
            Television Professionals
          </HeroTitle>
          <HeroText>
            AI tools that save your team countless hours, leaving more time to create.
          </HeroText>
          <HeroSectionButton onClick={signUpClickHandler}>
            <HeroBtnRight className="right-icon" />
            <div className="request-demo-btn">Try for Free</div>
            <HeroBtnLeft className="left-icon" />
          </HeroSectionButton>
        </HeroSection>
      </ContentWrapper>
      {isShow && (
        <Menu>
          <NavButtonsWrapper>
            <StartButtons>
              <Button
                onClick={signUpClickHandler}
                variant="ghost"
                className="ghost !text-[#000000]">
                START COVERAGE
              </Button>
              <Button onClick={loginClickHandler} variant="ghost" className="ghost !text-[#000000]">
                LOG IN
              </Button>
            </StartButtons>

            <RequestDemoButton
              element="link"
              to="https://calendly.com/fullframe-support/30min?month=2023-09">
              Request Demo
            </RequestDemoButton>
          </NavButtonsWrapper>
        </Menu>
      )}
    </Wrapper>
  );
}
